/* eslint-disable */
import React, { useEffect, useState } from 'react'
import About from './About'
import Related from './Related'
import { Category } from '../../../models/blog'
import axios from 'axios'
import toast from 'react-hot-toast'

interface Props {
  category?: Category[]
}

export default function SideBar(props: Props) {
  const [relatedPosts, setRelatedPosts] = useState([])
  const fetchRelatedPosts = () => {
    if (props.category) {
      const categoryId = props.category[0].cat_ID
      if (categoryId) {
        axios
          .get(
            `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wpr/v1/category/${categoryId}`
          )
          .then(resp => {
            if (resp.data.length > 0) {
              setRelatedPosts(resp.data)
            }
          })
          .catch(err => toast.error(err.response))
      }
    }
  }

  useEffect(() => {
    fetchRelatedPosts()
  }, [props.category])

  return (
    <div className="relative lg:sticky top-8 max-h-screen">
      <About />
      {relatedPosts.length > 0 && <Related posts={relatedPosts} />}
    </div>
  )
}
